import axios from '../base/axios';
import API_KEY from './key';

const GET_TVDOCUMENTARY = 'flixfrenzy/redux/GET_TVDOCUMENTARY';

// eslint-disable-next-line default-param-last
const tvDocumentaryReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVDOCUMENTARY:
      return action.payload;
    default:
      return state;
  }
};

export const getTvDocumentary = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=99`).then((res) => {
    dispatch({
      type: GET_TVDOCUMENTARY,
      payload: res.data,
    });
  });
};

export default tvDocumentaryReducer;
